// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_2PJOK97LduYQThWVTFpdoj","block":"_1VDbZiDUnjwYsBP3_jVjGo","blockName":"yzL56rLGVbGSBJhaLzVjy","blockValue":"YXf_ofFk264w5ruoEvljr","date":"xduZLz4QHwWFKwp8MKSw5"};